import { render, staticRenderFns } from "./PPScheme.vue?vue&type=template&id=50e9b4b0"
import script from "./PPScheme.vue?vue&type=script&lang=js"
export * from "./PPScheme.vue?vue&type=script&lang=js"
import style0 from "./PPScheme.vue?vue&type=style&index=0&id=50e9b4b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports